import { useScreenDetector } from '../../hooks';
import { RenderOn } from '../RenderOn/RenderOn';
import { SSOCTAs } from '../../SSObuttons/SSOCTAs';
import styles from './BurgerTOCComponent.module.scss';
import { useTOCMembership } from './useTOCMembership';
import { OneClubMastercardFull } from '../../icons';
import { GraphicSquareLiliacBg } from '../../icons';

export function BurgerTOCComponent() {
  const { isMobile } = useScreenDetector();
  const { title, subtitle } = useTOCMembership();

  return (
    <RenderOn condition={isMobile}>
      <div className={styles['wrapper']}>
        <div className={styles['background__image']}>
          <GraphicSquareLiliacBg
            className={styles['icon-group__item']}
            width={391}
            height={378}
          />
        </div>
        <div className={styles['content']}>
          <OneClubMastercardFull
            className={styles['icon-group__item']}
            width={300}
            height={107}
          />
          <div className={styles['title']}>{title}</div>
          <div className={styles['subtitle']}>{subtitle}</div>
          <SSOCTAs />
        </div>
      </div>
    </RenderOn>
  );
}

export default BurgerTOCComponent;
